// extracted by mini-css-extract-plugin
export default {"anchor":"wJRZOW","pill":"qVs79u","lastUsedBadgeIn":"zF66hu","corner":"m6qovc","under":"Nt9Y7_"};